// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2s_Y0","inner":"Footer_inner__1llPr"};